export default __webpack_public_path__ + "static/media/vip-icon.47a5a64a.webp";